import React from 'react'
import './style.css'

const RedeemDealModal = (props) => {

    return (
        <>
            <div className="mm-question">
                <p>
                    Are you sure you want to redeem this deal of {props.title}? 
                    <br />
                    It will no longer be available upon redeeming.
                </p>
            </div>
            <div className="mm-button-confirm">
                <button onClick={props.onConfirm}>
                    REDEEM
                </button>
            </div>
            <div className="mm-button mm-button-close">
                <button onClick={props.onClose}>
                    CANCEL
                </button>
            </div>
        </>
    )
}

export default RedeemDealModal